import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8498177e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-d-flex p-ai-center p-px-3" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Wallet", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"flex-grow":"1"} }, null, -1))
const _hoisted_4 = { class: "p-d-flex p-jc-around" }
const _hoisted_5 = {
  key: 0,
  class: "p-mt-4"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_qr_scan = _resolveComponent("qr-scan")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Chip = _resolveComponent("Chip")!
  const _component_Card = _resolveComponent("Card")!
  const _component_DisplayController = _resolveComponent("DisplayController")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.store.getters.camera_scan_mode)
      ? (_openBlock(), _createBlock(_component_qr_scan, {
          key: 0,
          account_id: _ctx.account?.id
        }, null, 8, ["account_id"]))
      : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("div", null, [
      _createVNode(_component_Card, {
        class: "controller-card",
        style: {"margin-top":"20px"}
      }, {
        header: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _hoisted_2,
            _hoisted_3,
            (!(_ctx.web3_modal && _ctx.signature && _ctx.account))
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 0,
                  label: "Connect",
                  icon: _ctx.loading_account ? 'pi pi-spin pi-spinner' : 'pi pi-wifi',
                  onClick: _ctx.connectAccount
                }, null, 8, ["icon", "onClick"]))
              : (_openBlock(), _createBlock(_component_Button, {
                  key: 1,
                  class: "p-button-text",
                  icon: "pi pi-check",
                  label: "Connected"
                }))
          ])
        ]),
        content: _withCtx(() => [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_Chip, {
              label: "Web3",
              icon: _ctx.web3_modal ? 'pi pi-check' : 'pi pi-times',
              style: _normalizeStyle({color: _ctx.web3_modal ? '#4CAF50' : '#F44336'})
            }, null, 8, ["icon", "style"]),
            _createVNode(_component_Chip, {
              label: "Metamask",
              icon: _ctx.signature ? 'pi pi-check' : 'pi pi-times',
              style: _normalizeStyle({color: _ctx.signature ? '#4CAF50' : '#F44336'})
            }, null, 8, ["icon", "style"]),
            _createVNode(_component_Chip, {
              label: "Moda Archives",
              icon: _ctx.account ? 'pi pi-check' : 'pi pi-times',
              style: _normalizeStyle({color: _ctx.account ? '#4CAF50' : '#F44336'})
            }, null, 8, ["icon", "style"])
          ]),
          (_ctx.tokens)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(`${_ctx.tokens.length} token${_ctx.tokens.length == 1 ? '' : 's'} loaded from OpenSea.`), 1))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_component_DisplayController, {
        account_id: _ctx.account?.id
      }, null, 8, ["account_id"])
    ], 512), [
      [_vShow, !_ctx.store.getters.camera_scan_mode]
    ])
  ], 64))
}